enum DNDType {
    WIDGET = 'Widget',
}

export default DNDType;
